import { type CloudAnalyticsModelAttributionGroupsModel } from "@doitintl/cmp-models";
import { type ModelReference, type WithModel } from "@doitintl/models-any";

export type AttributionTransform = {
  owner?: string;
  timeModified: string;
};

export type AttributionGroupWithRef = {
  data: WithModel<CloudAnalyticsModelAttributionGroupsModel>;
  ref: ModelReference<CloudAnalyticsModelAttributionGroupsModel>;
  transform: AttributionTransform;
};

export enum FilterModeOption {
  IS = "is",
  IS_NOT = "is not",
  STARTS_WITH = "starts with",
  ENDS_WITH = "ends with",
  CONTAINS = "contains",
  DOES_NOT_CONTAIN = "does not contain",
  MATCHES_REGEX = "matches regex",
  DOES_NOT_MATCHES_REGEX = "does not match regex",
}
